import { Component, OnInit, ViewChild, Input } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import {
  FormArray,
  FormGroup,
  FormControl,
  FormBuilder,
  Validators,
} from "@angular/forms";
import { MatTableDataSource, MatSort, MatPaginator } from "@angular/material";
import { Sort } from "@angular/material/sort";
import { ToastService } from "ng-uikit-pro-standard";
import { DataService } from "../../data.service";

@Component({
  selector: "app-metalayoutlist",
  templateUrl: "./metalayoutlist.component.html",
  styleUrls: ["./metalayoutlist.component.scss"],
})
export class MetaLayoutListComponent implements OnInit {
  @Input() metaobjectid: string;
  @Input() objectname: string;
  @Input() parentobjectid: string;
  @Input() parentobjectname: string;
  @Input() embeddedobject: boolean;
  @Input() metalayoutname: string;
  @Input() displayname: string;

  matSort: any;
  isLoading = false;
  isError = false;
  errorMessage = "";
  metaobjectId = "";
  objectName = "";
  metalayoutList = [];
  parentobjectId = "";
  parentobjectName = "";
  embeddedObject = false;
  profileId = "";
  metalayoutName = "";
  displayName = "";

  displayedColumns: string[] = [
    "id",
    "name",
    "action",
    "parentobjectname",
    "modifiedby",
    "modifieddate",
    "active",
  ];
  dataSource = new MatTableDataSource();

  sorting = {
    fieldName: "name",
    order: "ASC",
  };

  sortData(sort: Sort) {
    console.log("sort", sort);
    if (!sort.active || sort.direction === "") {
      //default sorting
      this.sorting.fieldName = "createddate";
      this.sorting.order = "ASC";
    } else {
      const isAsc = sort.direction.toLocaleUpperCase() === "ASC";
      this.sorting.fieldName = sort.active;
      if (isAsc) {
        this.sorting.order = "ASC";
      } else {
        this.sorting.order = "DESC";
      }
    }

    this.getMetalayoutByName().then((res) => {
      console.log("response11111", res);
    });
  }

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private fb: FormBuilder,
    private dataService: DataService,
    private toastrService: ToastService
  ) {}

  ngOnInit() {
    this.metaobjectId = this.metaobjectid;
    this.objectName = this.objectname;
    this.parentobjectId = this.parentobjectid;
    this.parentobjectName = this.parentobjectname;
    this.embeddedObject = this.embeddedobject;
    this.metalayoutName = this.metalayoutname;
    this.displayName = this.displayname;

    console.log("this.embeddedobject", this.embeddedobject);

    var userDetail = JSON.parse(localStorage.getItem("crm_userdetails"));
    this.profileId = userDetail.profileid;
    //load fields
    this.getMetalayoutByName().then((res) => {
      console.log("response11111", res);
    });
  }

  showSuccess(data: any) {
    let options = {
      enableHtml: true,
      positionClass: "md-toast-top-right",
      timeOut: 3000,
    };
    this.toastrService.success(data, "", options);
  }
  showError(data: any) {
    let options = { enableHtml: true, positionClass: "md-toast-bottom-right" };
    this.toastrService.error(data, "Application Error!", options);
  }

  showWarning(data: any) {
    let options = {
      enableHtml: true,
      positionClass: "md-toast-bottom-right",
      messageClass: "orange darken-4",
      toastClass: "warning-color-dark",
    };
    this.toastrService.warning(data, "", options);
  }

  newLayout() {
    this.router.navigateByUrl(
      "/home/metalayout/new/" +
        this.metaobjectId +
        "/" +
        this.objectName +
        "/" +
        this.profileId
    );
  }

  metaobjectList() {
    this.router.navigateByUrl("home/metaobjectlist");
  }

  delete(id: number) {
    // alert(id)
    const organizationid = localStorage.getItem("crm_orgid");
    const domain = localStorage.getItem(
      `${localStorage.getItem("crm_orgid")}.domain`
    );
    const subdomain = localStorage.getItem(
      `${localStorage.getItem("crm_orgid")}.subdomain`
    );
    const confirmDelete = window.confirm("Are you sure you want to delete?");

    if (!confirmDelete) {
      return;
    }
    this.isLoading = true;
    this.dataService
      .deleteMetalayout(
        organizationid,
        domain,
        subdomain,
        this.metaobjectid,
        id
      )
      .subscribe(
        (res) => {
          // alert('****res****' + JSON.stringify(res));
          console.log(res);
          if (res.success == 1) {
            // alert("Are you sure?")
            window.location.reload();

            this.isLoading = false;

            this.showSuccess(res.message);
          } else {
            console.log("error while deleting!");
            this.isLoading = false;
            this.showError(res.message);
          }
        },
        (err) => {
          console.log("Error***:", err);
          this.errorMessage = err.message;
          this.isError = true;
          this.isLoading = false;
          this.showError(err.message);
        }
      );
  }

  getMetalayoutByName() {
    return new Promise((resolve, reject) => {
      console.log("getMetalayoutByName");

      let postOption = {
        organizationid: localStorage.getItem("crm_orgid"),
        userid: localStorage.getItem("crm_userid"),
        username: localStorage.getItem("crm_username"),
        // domain: localStorage.getItem("domain"),
        // subdomain: localStorage.getItem("subdomain"),
        domain: localStorage.getItem(
          `${localStorage.getItem("crm_orgid")}.domain`
        ),
        subdomain: localStorage.getItem(
          `${localStorage.getItem("crm_orgid")}.subdomain`
        ),
        data: {
          sortfield: this.sorting.fieldName,
          sortorder: this.sorting.order,
          metalayout: {
            metaobjectid: this.metaobjectId,
            // layouttype: "Page Layout",
            // name: "AcademicSession_New_general",
          },
        },
      };
      console.log("postOption", postOption);

      this.isLoading = true;
      this.dataService.getLayouts(postOption).subscribe(
        (res) => {
          console.log("metalayout list", res);
          if (res !== null && res.success == 1) {
            // this.metalayoutList = res.data.metalayouts;
            this.metalayoutList = res.data.metalayouts.filter(
              (layout) =>
                layout.layouttype === null ||
                layout.layouttype === "Page Layout" ||
                layout.layouttype === "undefined"
            );

            //assign table data will refresh it automatically
            this.dataSource.data = this.metalayoutList;
            console.log(this.metalayoutList);

            this.isLoading = false;
            resolve(null);
          } else {
            console.log("No layouts data!");
            this.errorMessage = res != null ? res.message : "No layouts data!";
            this.isError = true;
            this.isLoading = false;
            resolve(null);
          }
        },
        (err) => {
          console.log("Error***:", err);
          this.errorMessage = err.message;
          this.isError = true;
          this.isLoading = false;
          resolve(null);
        }
      );
    });
  }
}
